import Chart from 'chart.js'

// this overwrites the default drawPoint function for the bubble graph
// add a dataLabels property to any dataset in which you want to add either an image or text to your bubbles
// dataLabels.image for images on bubbles
// dataLabels.label for text on the bubble
// dataLabels.rightLabel for text that you want to hang off the right side of the bubble

let data
const renderedImages = []

Chart.canvasHelpers.defaultDrawPoint = Chart.canvasHelpers.drawPoint
Chart.canvasHelpers.drawPoint = function (ctx, pointStyle, radius, x, y) {
  if (pointStyle === undefined || pointStyle === 'circle') {
    ctx.beginPath()
    ctx.arc(x, y, radius, 0, Math.PI * 2)
    ctx.closePath()
    ctx.fill()
    if (data) {
      const datasetPoint = data.find(data => {
        // console.log(data.data[0].foo)
        // TODO: retrieve attribute name once it has it
        return data.data[0].r === radius
      })
      if (datasetPoint && datasetPoint.dataLabels) {
        if (datasetPoint.dataLabels.image) {
          renderImageURLLabel(ctx, datasetPoint.dataLabels.image, {r: radius, x, y})
          return
        }
        if (datasetPoint.dataLabels.label) {
          renderTextLabel(ctx, datasetPoint.dataLabels.label, {r: radius, x, y})
        }
        if (datasetPoint.dataLabels.rightLabel) {
          renderTextLabelRight(ctx, datasetPoint.dataLabels.rightLabel.replace('&AMP;', '&').replace('&amp;', '&'), {r: radius, x, y})
        }
      }
    }
  } else {
    Chart.canvasHelpers.defaultDrawPoint(ctx, pointStyle, radius, x, y)
  }
}

// this sets the data for the override function to use while rendering the chart
// needed due to the chartJS helper drawPoint not having any context to the data
export const setDataForBubblesPlugin = function (newData) {
  data = newData
}

// draws the image to the bubble
const renderImageURLLabel = function (ctx, url, { r, x, y }) {
  const cachedImage = renderedImages.find(({ src }) => src === url)
  if (cachedImage) {
    let newSize = findMaxSizeForImage(cachedImage, r)
    ctx.drawImage(cachedImage, (x - (newSize.width / 2)), (y - (newSize.height / 2)), newSize.width, newSize.height)
  } else {
    const image = new Image()
    image.src = url
    image.crossOrigin = 'Anonymous'
    image.onload = function () {
      setTimeout(() => {
        if (renderedImages.find(({ src }) => src === this.src)) return
        let newSize = findMaxSizeForImage(this, r)
        ctx.drawImage(image, (x - (newSize.width / 2)), (y - (newSize.height / 2)), newSize.width, newSize.height)
        renderedImages.push(image)
      }, 0)
    }
  }
}

// draws the text in the middle of the bubble
const renderTextLabel = function (ctx, label, { r, x, y }) {
  if (!label) return
  // set font at initial scale so we can then come up with a better size
  ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'bold', Chart.defaults.global.defaultFontFamily)
  const defaultLabelWidth = ctx.measureText(label).width
  const desiredWidth = (r * 2) * 0.7
  let newFontSizeToReachDesiredWidth = Chart.defaults.global.defaultFontSize * (desiredWidth / defaultLabelWidth)
  // double check new font size isn't taller then the bubble
  if (newFontSizeToReachDesiredWidth > desiredWidth) {
    newFontSizeToReachDesiredWidth = desiredWidth
  }
  // set new size for font
  ctx.font = Chart.helpers.fontString(newFontSizeToReachDesiredWidth, 'bold', Chart.defaults.global.defaultFontFamily)
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = '#fff'
  ctx.fillText(label, x, y)
}

// draws the text right of the bubble
const renderTextLabelRight = function (ctx, label, { r, x, y }) {
  if (!label) return
  // set font at initial scale so we can then come up with a better size
  ctx.font = Chart.helpers.fontString(10, 'bold', Chart.defaults.global.defaultFontFamily)
  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = '#435262'
  ctx.fillText(label, (x + r + 5), y)
}

// calculates the size of the image to be drawn in the bubble
const findMaxSizeForImage = function (image, maxSize) {
  let width, height, ratio
  if (image.width > image.height) {
    ratio = image.height / image.width
    width = maxSize
    height = maxSize * ratio
  } else {
    ratio = image.width / image.height
    width = maxSize * ratio
    height = maxSize
  }
  return {
    height,
    width
  }
}




// WEBPACK FOOTER //
// ./src/app/appComponents/graphs/bubbleLabelPlugin.js